import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { RiskEngineName } from 'types/risk';
import { ViewRiskScoreData } from 'services/risk-checker/type';

interface RiskCheckerState {
  engineName: RiskEngineName | null;
  viewRiskDetails: ViewRiskScoreData | null;
}

interface RiskCheckerAction {
  setEngineName(name: RiskEngineName | null): void;
  setViewRiskDetails(details: ViewRiskScoreData): void;
  clearRiskStore: () => void;
}

const initialState: RiskCheckerState = {
  engineName: null,
  viewRiskDetails: null,
};

type RiskCheckerStore = RiskCheckerState & RiskCheckerAction;

const useRiskCheckerStore = create<RiskCheckerStore>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        setEngineName: (name) => set({ engineName: name }),
        setViewRiskDetails: (details) => set({ viewRiskDetails: details }),
        clearRiskStore: () => set(initialState),
      }),
      { name: 'risk-checker' }
    )
  )
);

export default useRiskCheckerStore;
